import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import { paramPropType } from '../../../shared/customReports/propTypes';
import { OptionsPropType } from '../../../shared/propTypes/common';
import Spinner from '../../../shared/spinner.component';

import ParamForm from '../shared/ParamForm.component';

class TestCustomReportSetForm extends PureComponent {
  static propTypes = {
    readOnly: PropTypes.bool.isRequired,
    isFetchingCustomReportParams: PropTypes.bool.isRequired,

    updateQueryParams: PropTypes.func.isRequired,
    fetchCustomReportParams: PropTypes.func.isRequired,

    queryParams: PropTypes.objectOf(PropTypes.string.isRequired),
    uniqueParams: PropTypes.arrayOf(paramPropType.isRequired),
    customReportParamsOptions: PropTypes.objectOf(OptionsPropType),
  };

  componentDidMount() {
    this.fetchQueryParamsDropdownData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.uniqueParams !== prevProps.uniqueParams || this.props.queryParams !== prevProps.queryParams) {
      this.fetchQueryParamsDropdownData();
    }
  }

  fetchQueryParamsDropdownData = debounce(() => {
    const {
      uniqueParams,
      fetchCustomReportParams,
      queryParams,
    } = this.props;

    const queryParamsMapped = uniqueParams.reduce((acc, { name, id }) => {
      acc[name] = queryParams[id] || '';
      return acc;
    }, {});

    fetchCustomReportParams(uniqueParams, queryParamsMapped);
  }, 1000);

  render() {
    const {
      queryParams,
      uniqueParams,
      readOnly,
      updateQueryParams,
      customReportParamsOptions,
      isFetchingCustomReportParams,
    } = this.props;

    const paramsForm = uniqueParams
      ? <ParamForm
        readOnly={readOnly}
        params={uniqueParams}
        queryParams={queryParams}
        updateQueryParams={updateQueryParams}
        customReportParamsOptions={customReportParamsOptions}
      />
      : null;

    return (
      <div className="col-sm-12 col-lg-6">
        {isFetchingCustomReportParams ? <Spinner /> : paramsForm}
      </div>
    );
  }
}

export default TestCustomReportSetForm;
